module.exports = __webpack_public_path__ + "img/doctor_avatar_cropped.7595a03a.png";